module.exports = __webpack_public_path__ + "img/light.bfda9578.png";